var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ca4f59465fabb4be3071b07c697da76f",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34294",
    "data-name": "Path 34294",
    d: "M12.917,10.4H3.708a.7.7,0,1,1,0-1.4h9.208a.7.7,0,1,1,0,1.4Zm6.375,0H16.458a.7.7,0,1,1,0-1.4h2.833a.7.7,0,1,1,0,1.4Z",
    transform: "translate(-3 -7.249)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34295",
    "data-name": "Path 34295",
    d: "M14.688,11.448a2.474,2.474,0,1,1,2.479-2.474A2.477,2.477,0,0,1,14.688,11.448Zm0-3.534a1.06,1.06,0,1,0,1.063,1.06A1.061,1.061,0,0,0,14.688,7.914Zm4.6,8.836H10.083a.707.707,0,1,1,0-1.414h9.208a.707.707,0,1,1,0,1.414Zm-12.75,0H3.708a.707.707,0,1,1,0-1.414H6.542a.707.707,0,1,1,0,1.414Z",
    transform: "translate(-3 -6.5)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34296",
    "data-name": "Path 34296",
    d: "M9.451,21.4A2.451,2.451,0,1,1,11.9,18.951,2.451,2.451,0,0,1,9.451,21.4Zm0-3.5a1.05,1.05,0,1,0,1.05,1.05A1.05,1.05,0,0,0,9.451,17.9Z",
    transform: "translate(-4.153 -9.402)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.19c8c3c758380bf856e99d6d6bd7b103.svg";
export { ForwardRef as ReactComponent };